import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'

interface Props {
  target: string
  range: string
  work_style_id: number
  occupation_id: number
  is_standard?: boolean
}

const DeviationHeader: FC<Props> = (props) => {
  const {
    target,
    range,
    work_style_id,
    occupation_id,
    is_standard,
  } = props

  const {
    profile,
  } = useSelector((state: RootState) => (state))

  return (
    <div className="indicator_head">
      <div className="left">
        <div className="left_area" />
        <div className={`labels ${target}`}>
          {
            target === "team" ? (
              <>
                <div>
                  {range === "monthly" ? "今月" : "今週"}
                </div>
                <div>
                  {range === "monthly" ? "先月" : "先週"}
                </div>
                <div>
                  会社平均
                </div>
                {
                  is_standard ? (
                    <div>
                      Qasee基準
                    </div>
                  ) : (
                    <div>
                      Qasee平均
                    </div>
                  )
                }
              </>
            ) : (
              <>
                <div>
                  {range === "monthly" ? "今月" : "今週"}
                </div>
                <div>
                  {range === "monthly" ? "先月" : "先週"}
                </div>
                <div>
                  チーム平均
                </div>
                <div>
                  会社平均
                </div>
                <div>
                  職種平均
                </div>
              </>
            )
          }
        </div>
      </div>
      <div className="right">
        {
          range === "weekly" && target === "member" ? (
            <>
              {
                work_style_id ? (
                  <div className="tips">
                    <div className="tip_wrap">
                      <div className="tip">
                        {
                          profile.work_style_list.find(
                            (work_style) => work_style.id === work_style_id,
                          )?.description
                        }
                      </div>
                    </div>
                    <img
                      alt=""
                      src={`/static/images/work_style/${work_style_id || 0}.png`}
                      className="icon"
                    />
                  </div>
                ) : (
                  <></>
                )
              }
              {
                occupation_id ? (
                  <div className="tips">
                    <div className="tip_wrap">
                      <div className="tip">
                        {
                          profile.occupationList.find(
                            (occupation) => occupation.id === occupation_id,
                          )?.description
                        }
                      </div>
                    </div>
                    <img
                      alt=""
                      src={`/static/images/occupation/${occupation_id || 0}.png`}
                      className="icon"
                    />
                  </div>
                ) : (
                  <></>
                )
              }
            </>
          ) : (
            <></>
          )
        }
      </div>
    </div>
  )
}

DeviationHeader.defaultProps = {
  is_standard: false,
}

export default DeviationHeader
